import { number, object } from "yup";
import { dateMax, stringMax } from "./utils";

export const propertyFolderHeadSchema = object({
  nom: stringMax(250).required("Le nom est obligatoire"),
  date_achat: dateMax().optional(),
  prix_achat: number()
    .integer("Veuillez spécifier un nombre entier")
    .optional(),
  surface_total: number()
    .integer("Veuillez spécifier un nombre entier")
    .optional(),
  id_profile_nom_owner: number().required(
    "Vous devez selectionner un profil bailleur",
  ),
});
